import {createRouter, createWebHashHistory} from 'vue-router'

function view(path, name, component) {
  return {path, name, meta: {title: name}, component}
}

function viewT(path, name, component) {
  return {path, name, meta: {title: ''}, component}
}

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    meta: {title: "安徽四建控股集团有限公司"},
    component: () => import('@/views/home/home.vue')
  },
  view("/companyOverview", "关于我们", () => import('@/views/menu/companyOverview')),
  viewT("/companyProfile", "企业简介", () => import('@/views/menu/companyProfile')),
  view("/honor", "荣誉资质", () => import('@/views/menu/honor')),
  view("/companyNews", "新闻中心", () => import('@/views/menu/companyNews')),
  view("/partyMassWork", "党群工作", () => import('@/views/menu/companyNews')),
  view("/companyCulture", "企业文化", () => import('@/views/menu/companyCulture')),
  view("/technicalInnovation", "科技创新", () => import('@/views/menu/companyTechnology')),
  view("/businessArea", "业务领域", () => import('@/views/menu/businessArea')),
  view("/humanResources", "人力资源", () => import('@/views/menu/companyNews')),
  view("/contactUs", "联系我们", () => import('@/views/menu/contactUs')),
  view("/detail", "详情", () => import('@/views/home/newsInfo')),
  view("/recruitDetail", "招聘详情", () => import('@/views/home/recruitDetail')),
]

const router = createRouter({
  history: createWebHashHistory(),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes,
});

export default router
